export default "__VITE_ASSET__7657cce0__"